import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, Divider } from 'day8-ui';

const PayLaterOption = ({
  firstDeadlineDays,
  checkoutBooking,
  booking,
  isYachtsAndFriends
}) => {
  const [formData, setFormData] = useState({});
  const [reserving, setReserving] = useState(false);

  let firstDeadlineText = '24 hours';
  if (firstDeadlineDays > 1) {
    firstDeadlineText = `${firstDeadlineDays} days`;
  }

  const handleFormChange = e => setFormData({
    ...formData,
    [e.target.name]: e.target.checked
  });
  const pressedCheckout = async bookingId => {
    setReserving(true);
    const booking = await checkoutBooking(bookingId);
    if (!booking) {
      // No need to set back state if booking is ok, then we have already moved on to success page
      setReserving(false);
    }
  };
  return (
    <div>
      <Divider className="dui-my-4" />
      <p>Selecting this option places you on a three instalment payment plan. By continuing, you will be reserving your {booking.subject} now, with {firstDeadlineText} to complete your deposit payment.</p>
      <div className="dui-mt-4">
        <Checkbox
          id="pay-later-terms-agreed"
          name="termsAgreed"
          className="dui-shrink-0 dui-self-start dui-cursor-pointer"
          onChange={e => handleFormChange(e)}
          options={[({
            label: (
              <Fragment>
                  I agree to {isYachtsAndFriends ? "Yachts and Friend's" : "Yacht Week's"}{' '}
                <a className="d8-u-color-secondary" href={`https://www.theyachtweek.com/terms-and-conditions?companyId=${booking.week.company.id}`} target="_blank">
                    Terms and Conditions
                </a>
                {' '}
                {!isYachtsAndFriends && <span>- I confirm all my crew will be aged 20 or over during the event</span>}
              </Fragment>
            ),
            value: formData.termsAgreed,
            checked: formData.termsAgreed
          })]}
        />
      </div>
      <Button disabled={!formData.termsAgreed || reserving} className='dui-mt-4 dui-w-full' onClick={() => pressedCheckout(booking.id)}>
        {reserving ? 'Reserving...' : `Reserve for ${firstDeadlineText}`}
      </Button>
    </div>
  );
};

PayLaterOption.propTypes = {
  booking: PropTypes.object,
  isYachtsAndFriends: PropTypes.bool,
  girls: PropTypes.number.isRequired,
  guys: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  setActivePaymentOption: PropTypes.func.isRequired,
  checkoutBooking: PropTypes.func.isRequired,
  firstDeadlineDays: PropTypes.number
};

export default PayLaterOption;
